export default function(dom, opts) {
	let options = {
		baseClass: 'collapsible',
		triggerSelector: null,
		contentSelector: null,
		collapsedClass: null,
		callback: () => {},
		...opts
	};

	const triggerSelector = options.triggerSelector || `.${options.baseClass}__trigger`;
	const contentSelector = options.contentSelector || `.${options.baseClass}__content`;
	const collapsedClass = options.collapsedClass || `${options.baseClass}--collapsed`;

	const trigger = dom.querySelector(triggerSelector);
	const content = dom.querySelector(contentSelector);

	content.addEventListener('transitionend', () => {
		content.style.maxHeight = '';
		options.callback(dom.classList.contains(collapsedClass));
	})

	function setMaxHeight() {
		content.style.maxHeight = `${content.scrollHeight}px`;
	}

	function open() {
		if (dom.classList.contains(collapsedClass)) {
			setMaxHeight();

			setTimeout(() => {
				dom.classList.remove(collapsedClass);
			}, 25);
		}
	}

	function close() {
		if (!dom.classList.contains(collapsedClass)) {
			setMaxHeight();

			setTimeout(() => {
				dom.classList.add(collapsedClass);
			}, 25);
		}
	}

	function toggle() {
		setMaxHeight();

		setTimeout(() => {
			dom.classList.toggle(collapsedClass);
		}, 25);
	}

	trigger && content && trigger.addEventListener('click', e => {
		e.preventDefault();

		toggle();

		return false;
	});

	return {
		el: dom,
		open,
		close,
		toggle,
	}
}
